import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar/Sidebar";

import "./BasePage.scss";
import SidebarFooter from "../../Components/Sidebar/SidebarFooter";
import NavigationHeader from "./../../Components/NavigationHeader/NavigationHeader";
import useActivePath from "./../../CustomHooks/useActivePath";
import PATH from "./../../constants/routes";
import Search from "./../../Components/Search/Search";
import { BiWindow } from "react-icons/bi";
import NavbarSearch from "./../../Components/NavbarSearch/NavbarSearch";
import NavbarSearchWrapper from "../NavbarSearchWrapper/NavbarSearchWrapper";

export default function BasePage() {
  const { urlPaths } = useActivePath();

  const [screenWidth, setScreenWidth] = useState<number>(document.body.clientWidth);

  useEffect(() => {
    let timeoutFlag;
    window.addEventListener("resize", () => {
      clearTimeout(timeoutFlag);
      timeoutFlag = setTimeout(() => {
        setScreenWidth(document.body.clientWidth);
      }, 100);
    });
  }, []);

  let showNavigationPath = false;
  let showSearchBox = false;
  let showFooter = true;
  let showNavbar = true;
  let showSidebar = true;

  if (urlPaths.length === 2 && screenWidth <= 468 && !(urlPaths[1] === "")) {
    showSearchBox = true;
  } else if (urlPaths.length > 2 && screenWidth <= 468) {
    showNavigationPath = true;
  }

  // for quiz game play hide sidebar and navbar
  if (urlPaths.includes(PATH.PLAY_QUIZ_LINK) || urlPaths.includes(PATH.PLAY_TEST_LINK)) {
    showSidebar = false;
    showNavbar = false;
  }
  console.log("pathssss", urlPaths.includes(PATH.PLAY_QUIZ_LINK));

  //for footer
  if (urlPaths.length > 2) showFooter = false;

  return (
    <div>
      <div className="navbar_wrapper">{showNavigationPath ? <NavigationHeader /> : showSearchBox ? <NavbarSearchWrapper /> : showNavbar && <Navbar />}</div>
      <div className="main_wrapper">
        <div className="main_container">
          {showSidebar && (
            <div className="sidebar_wrapper">
              <Sidebar />
            </div>
          )}
          <div className="main_content_wrapper">
            <Outlet />
          </div>
        </div>
        {showFooter && (
          <div className="sidebar_footer_container">
            <SidebarFooter />
          </div>
        )}
      </div>
    </div>
  );
}
